import React, { useState } from "react";
import { APP_NAME,checkTime } from "../constant/constant";
import "./home.css"
import { useDispatch,useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { faPlayCircle} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import CommonModalPopup from "./CommonaModalPopUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { msgPromtsuccess } from "../features/userSlice";
const Home = () => {
    const { all_games,Info} = useSelector((state) => state.users);
   const [openModal,setOpenModal]=useState(false);
   const [content_type,setcontent_type]=useState( {content:''});
   const dispatch=useDispatch();
   const navigate=useNavigate();
   const closeModal=()=>{
        setOpenModal(false);
   }
      const getMygameUrl=(name,market_status)=>{
        if(market_status){
         let newName=name.split(' ').join('_');
         navigate(`/game_type/${newName}`);
        }else{
          dispatch(msgPromtsuccess({msg:`This Market Betting Is Closed For Today.`,error:true}));
          return false;
        }
      }


      const CommonModalOpener=(data)=>{
            setOpenModal(true);
            setcontent_type({
              content:data.TYPE,
              game_name:data.game_name,
              phone:data?.phone
            });
      }


     const stylesBorder={
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid #007bff', // Outer border
        borderRadius: '50%', // Circular shape
        padding: '4px', // Space between icon and border
      };
    return(
      <div>
        <div className="search-bar">
        {Info?.notification_head}
        </div>
        <div className="times_contact">
                <div style={{cursor:'pointer'}} onClick={()=>CommonModalOpener({TYPE:'CONNECT_SUPPORT',game_name:'',phone:Info?.helpNumber1})}><FontAwesomeIcon   icon={faWhatsapp} fontWeight='600' cursor='pointer' color="green"  size="1x" title="whatsapp" /><span style={{fontWeight:'600',color:'#007bff'}} className="text_color_red"> +91{Info?.helpNumber1}</span></div>
                <div style={{cursor:'pointer'}} onClick={()=>CommonModalOpener({TYPE:'CONNECT_SUPPORT',game_name:'',phone:Info?.helpNumber2})}><FontAwesomeIcon   icon={faWhatsapp} fontWeight='600' cursor='pointer' color="green"  size="1x" title="whatsapp" /><span style={{fontWeight:'600',color:'#007bff'}} className="text_color_red"> +91{Info?.helpNumber2}</span></div>
            </div>            
         <div className="content-container">
{all_games.map((data, index) => (
      
            // <div className="card">
            //     <div className="icon">
            //     <img src="home/images/logo.png" style={{borderRadius:'22%'}} alt={APP_NAME+" Icon"}/>
            //     </div>
            //     <div className="content">
            //     <h2>{data.games_name}</h2>
            //     <p><span>{data.open_time}</span> to {data.close_time}</p>
            //     <p><span>{data.open_pana}</span> {data.close_pana}</p>
            //     <p><span>{data.open_digit}</span> {data.close_digit}</p>
            //     </div>
            //     {(Info?.status=='1')?<div className="actions">
            //     {checkTime(data.close_time)?<Link to={getMygameUrl(data.games_name)}><button className="download-button">Play now</button></Link>:<button className="download-button disabled">Closed</button>}
            //     <div className="rating">
            //         <i className="fa-solid fa-star"></i>
            //         <i className="fa-solid fa-star"></i>
            //         <i className="fa-solid fa-star"></i>
            //         <i className="fa-solid fa-star"></i>
            //         <i className="fa-solid fa-star"></i>
            //         <span className="reviews">{checkTime(data.close_time)?<span className="openBlk">Market Open</span>:<span className="closeBlk">Market Closed</span>}</span>
            //     </div>
            //     </div>:''}
            // </div>

              <div className="game-card" key={index}>
                <div className="game_card_left">
                   <div className="game-name" >{data.games_name}</div>    
                   <div className="game-name" style={{color:'#007bff',fontSize:'19px'}}>{data.open_pana}-{data.open_digit}{data.close_digit}-{data.close_pana}</div>     
                   <div className="game-name" ><span className="reviews">{(data?.game_status!=='0' && checkTime(data.close_time))?<span className="openBlk">Betting Is Running Now</span>:<span className="closeBlk">Betting Is Closed For Today</span>}</span></div>      
                   <div className="times"  >
                    <div className="game_card_left_time">
                      <span>Last Bids Time Open : <span style={{color:'#007bff',fontSize:'small'}}>{data.open_time}</span></span> 
                      </div>|
                      <div className="game_card_right_time">
                           <span>Last Bids Time Open : <span style={{color:'#007bff',fontSize:'small'}}>{data.close_time}</span> </span>
                      </div>
                    </div>    
                </div>
                <div className="game_card_right">
        <FontAwesomeIcon onClick={()=>CommonModalOpener({TYPE:'CHART_INFO',game_name:data.games_name?.split(' ').join('_'),phone:Info?.helpNumber1})} icon={faCalendarDays} cursor='pointer' color="#007bff"  size="2x" title="Calendar" /><br/><br/><br/>
        {Info?.status==='1'&&<div onClick={()=>getMygameUrl(data.games_name,(data?.game_status!=='0' && checkTime(data.close_time)))}><div style={stylesBorder}>
             <FontAwesomeIcon icon={faPlayCircle} cursor='pointer' color="#007bff"  size="2x" title="play" />
         </div></div>}
                </div>
              
              </div>
    ))}

        <CommonModalPopup
        isOpen={openModal}
        closeModal={closeModal}
        data={content_type}
        />
            </div><br/><br/><br/>
        <style jsx>
         {` .logo {
      font-size: 20px;
      font-weight: bold;
    }

    .search-bar {
  width: 250px; /* Adjust width as needed */
  border-radius: 5px;
  box-shadow: 0 2px 5px #BDBDBD;
  width: 93%;
  margin-left: 4%;
  margin-bottom: 4%;
  border-radius: 16px;
}

.search-bar  {
  color: black;
  font-weight: 600;
  font-size: 16px;
  padding: 8px;
  font-family: inherit;
  border: none;
  outline: none;
  border-radius: 13px;
  border-left: 3px solid #007bff;
}
    .nav-icons {
      display: flex;
      align-items: center;
    }

    .times{
          display: flex;

    }
    .times_contact{
          display: flex;
          flex-direction: row;
          justify-content: space-around;
    }
      .game_card_left{
         width: 70%;

      }

      .game_card_right{
          width: 30%;
              text-align: right;

      }

       .game_card_left_time{
         width: 50%;

      }

      .game_card_right_time{
          width: 50%;
              text-align: right;

      }

    .nav-icon {
      margin-left: 10px;
      font-size: 20px;
    }

    .content-container {
      padding: 20px;
    }

    .game-card {
      background-color: #fff;
      padding: 15px;
      margin-bottom: 15px;
      border-radius: 9px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      display: flex;
     flex-direction: row;
    }

    .game-name {
      text-align: left;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 5px;
      color: #333; /* Adjust color as needed */
    }

    .game-details {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      color: #666; /* Adjust color as needed */
    }

    .game-status {
      font-size: 14px;
      color: #007bff;
      margin-bottom: 10px;
    }

    .game-actions {
      display: flex;
      justify-content: space-between;
    }

    .game-icon {
      margin-right: 10px;
      font-size: 20px;
    }

    /* Button Styles (adjust as needed) */
    .play-button {
      background-color: #007bfff;
      color: #fff;
      padding: 5px 10px;
      border-radius: 3px;
      border: none;
      cursor: pointer;
    }

    .calendar-icon {
      color: #333; /* Adjust color as needed */
    }
        `}
        </style>
    </div>

   
    )};

export default Home;